<template>
  <div class="app-container">
    <!-- 面包屑 -->
    <div class="crumbsBg">
      <div class="container">
        <div class="crumbs">
          <a class="active" href="/">首页</a>
          <span>资讯</span>
        </div>
      </div>
    </div>
    <!-- 面包屑 -->

    <!-- 左侧快速导航 start -->
    <div class="container rel hidden-xs hidden-sm">
      <div class="newsFastNav">
        <a v-for="item in subTypeList" href="javascript:void(0)"
           :class="item.newsTypeId == currentTypeId ? 'active':''"
           @click="changeSubType(item.newsTypeId)">{{ item.newsTypeName }}</a>
      </div>
    </div>
    <!-- 左侧快速导航 end -->

    <!-- 搜索框 -->
    <div class="container">
      <div class="row search-box">
        <div class="searchBox">
          <form class="newsSearch" @submit.prevent="doSearch">
            <input v-model="keywords" type="text" name="keywords" autocomplete="off" maxlength="20"
                   placeholder="考试通知、课程优惠、热点、关键词...">
            <input type="submit" value="搜索">
          </form>
        </div>
      </div>
    </div>

    <div class="container newsListShow">
      <div class="row">
        <!---列表展示 begin--->
        <div id="vue-app">
          <div v-show="showKeywords" class="keyTitle">
            以下为<span>{{ showKeywords }}</span>的搜索结果
          </div>

          <div v-show="newsListIsInit && newsList.length === 0" class="news-empty">
            <span>没有找到与 "{{ showKeywords }}" 相关的内容，请您换个条件试试吧~ </span>
          </div>

          <div v-show="!newsListIsInit" class="news-empty">
            <span>拼命加载中~ </span>
          </div>

          <div v-show="newsList.length > 0" class="imgList newsList">
            <ul>
              <li v-for="(item, index) in newsList" :key="index">
                <div class="box">
                  <a v-if="item.newsCover" target="_blank" :href="publicPath+'news/news-info?newsId=' + item.newsId"
                     class="newImg">
                    <p class="focusIn">
                      <img :src="item.newsCover">
                    </p>
                  </a>
                  <div class="newHead">
                    <a
                        target="_blank"
                        :href="publicPath+'news/news-info?newsId=' + item.newsId"
                        class="title"
                        v-html="searchKeywords(item.newsTitle)"
                    ></a>
                    <p class="desc" v-html="searchKeywords(item.newsSecondTitle)"></p>
                    <p class="sources">
                      <span class="source">{{ item.newsSource }}</span>
                      <span class="time">{{ item.publishTime | formatDate }}</span>
                      <span class="read"><i class="ivu-icon ivu-icon-ios-eye-outline"></i>{{ item.clickCount }}</span>
                      <span class=" tags">
                        <a v-for="tag in item.tags.split(',')" class="tag" @click="searchByTag(tag)"><span
                            v-html="searchKeywords(`# ${tag}#`)"># {{ tag }}#</span></a>
                      </span>
                    </p>
                  </div>
                </div>
              </li>
            </ul>
            <div class="pages-box">
              <Pagination :size="null" :page-info="pageInfo" @change="handleChange"></Pagination>
            </div>
          </div>
        </div>
        <!---列表展示 end--->
      </div>
    </div>
  </div>
</template>

<script>
import { newsApi } from '@/api/news';
import appCode from '@/assets/image/common/code-app.png';
import { WEB_PAGE_TDK_PAGE_ENUM } from '@/constant/seo.js';
import Pagination from '@/components/page-pagination';

export default {
  name: 'NewsList',
  layout: 'news',
  components: { Pagination },
  filters: {
    // 返回年月日
    formatDate (string, state) {
      if (state == 'dateMonth') {
        return string.substring(5, 10);
      }
      if (state == 'dateMonthTwo') {
        return string.substring(5, 10).replace(/-/g, '/');
      }
      if (state == 'dateMonthTime') {
        return string.substring(5, 19).replace(/-/g, '/');
      }
      if (state == 'dateHour') {
        const newHour = string.substring(11, 16).split(':');
        let hour = newHour[0];
        let minute = newHour[1];
        if (hour.length == 1) {
          hour = '0' + hour;
        }
        if (minute.length == 1) {
          minute = '0' + minute;
        }
        return hour + ':' + minute;
      }
      if (state == 'dateYear') {
        const newData = string.substring(0, 10).split('-');
        return newData[0] + '年' + newData[1] + '月' + newData[2] + '日';
      }
      if (string) {
        return string.substring(0, 10).replace(/-/g, '/');
      } else {
        return '';
      }
    }
  },
  props: {},
  async asyncData ({ app, query }) {
    // 快讯
    const quickResult = await newsApi.queryNewsList({ pageNum: 1, pageSize: 8 });
    return {
      quickList: quickResult.data.list
    };
  },
  data () {
    return {
      head: {},
      publicPath: '/',
      appCode,
      // 子类型列表
      subTypeList: [],
      // 当前typeId
      currentTypeId: null,
      keywords: '',
      showKeywords: '',
      // 列表
      newsList: [],
      // 资讯列表是否初始化了
      newsListIsInit: false,
      pageNum: 1,
      pageSize: 10,
      pageTotal: 0
    };
  },
  computed: {
    pageInfo () {
      return { // 分页组件传递的参数
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        pageTotal: this.pageTotal
      };
    }
  },
  mounted () {
    this.currentTypeId = this.$route.query.type || null;
    this.getSubTypeList();
    this.queryNews(this.currentTypeId);
    this.setHeader();
  },
  methods: {
    // 设置header
    async setHeader () {
      this.head = await this.$store.dispatch('seo/getSeoDetail', WEB_PAGE_TDK_PAGE_ENUM.NEWS.value);
    },
    // 修改子类型
    changeSubType (typeId) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.currentTypeId = typeId;
      this.pageNum = 1;
      this.newsList = [];
      this.queryNews(this.currentTypeId);
    },
    // 搜索
    doSearch (e) {
      this.pageNum = 1;
      this.newsList = [];
      this.showKeywords = this.keywords;
      this.queryNews(this.currentTypeId);
    },
    // 搜索关键字高亮
    searchKeywords (string) {
      let newString = string;
      const keywords = this.showKeywords;
      if (keywords) {
        newString = string.replace(
          keywords,
          '<span style="color: #EF8203;">' + keywords + '</span>'
        );
      }
      return newString;
    },
    // 获取某个子类型
    async getSubTypeList () {
      try {
        const result = await newsApi.getChildrenTypeList(0);
        if (result.data.length > 0) {
          this.subTypeList = [{
            newsTypeId: null,
            newsTypeName: '全部'
          }];
        }
        this.subTypeList.push(...result.data);
      } catch (e) {
        console.log(e);
        this.$smartSentry.captureException(e);
      }
    },
    // 查询资讯
    async queryNews (typeId) {
      try {
        this.$Spin.show();
        const result = await newsApi.queryNewsList({
          newsTypeId: typeId,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          keywords: this.keywords
        });
        this.pageTotal = result.data.total;
        this.newsList = result.data.list;
      } catch (e) {
        console.log(e);
        this.$smartSentry.captureException(e);
      } finally {
        this.$Spin.hide();
        this.newsListIsInit = true;
      }
    },
    // 分页页码切换事件
    handleChange (page) {
      this.pageNum = page.pageNum;
      this.pageSize = page.pageSize;
      this.queryNews(this.currentTypeId);
    },
    // 根据标签检索
    searchByTag (tag) {
      this.keywords = tag;
      this.doSearch();
    }
  },
  head () {
    return this.head;
  }
};
</script>
<style lang='less' scoped>
@import "./news-list.less";
</style>
